//示例路由

export default {
    'example/socket': resolve => require(['../example/Socket.vue'], resolve),
}



// WEBPACK FOOTER //
// ./src/routes/example.js